/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/prop-types */
import _ from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { Typography } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import { rdsTabulate } from '../../modules/rds';
import states, { stateFIPS } from '../../modules/states';
import { toPercent } from '../../modules/text';
import BarChart from '../BarChart';
import CountyContext from '../../contexts/CountyContext';
import StoryContext from '../../contexts/StoryContext';
import povertyIncome from './data';
import { composeWhereClause } from '../../modules/data';

function AveragePriceByChildAgePoverty({ height = 300 }) {
  const { stateCode } = useParams();
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const { countyCode, county } = useContext(CountyContext);
  const { primaryColor, secondaryColor } = useContext(StoryContext);

  useEffect(() => {
    function getRatesByAgeGroup() {
      let whereClause = `state_fips=${stateFIPS[stateCode.toUpperCase()]}`;
      whereClause += composeWhereClause({});

      if (countyCode) {
        whereClause += ` AND county_fips=${countyCode}`;
      }

      return rdsTabulate('ccdc', 'county_setting_group_rate_annual', {
        dims: 'age_group',
        measure: 'average_rate:AVG(rate)',
        where: whereClause,
        format: 'amcharts',
        inject: true,
      }, true);
    }

    if (stateCode && states[stateCode.toUpperCase()]) {
      Promise.all([getRatesByAgeGroup()])
        .then((responses) => {
          const rates = responses[0].parsedBody.dataProvider;
          const infants = _.find(rates, { age_group: 'Infants' });
          const toddlers = _.find(rates, { age_group: 'Toddlers' });
          infants.age_group = 'Infants and Toddlers';
          infants.average_rate = (infants.average_rate + toddlers.average_rate) / 2;
          _.pull(rates, toddlers);
          const d = rates.map((r) => {
            const dataItem = { ...r };
            dataItem['For a family of 3'] = r.average_rate / povertyIncome['Family of 3'];
            dataItem['For a family of 2'] = r.average_rate / povertyIncome['Family of 2'];
            return dataItem;
          });
          setData(d);
        })
        .catch((err) => {
          setError(err);
        })
        .finally(() => {
          setReady(true);
        });
    }
  }, [stateCode, countyCode]);

  const keys = ['For a family of 3', 'For a family of 2'];
  const groupKey = 'age_group';

  let title = 'Child Age - FPL';
  if (county) {
    title += ` - ${county} County`;
  }

  const formatterFunction = function formatterFunction(payload) {
    if (payload.value) {
      return `<b>${payload.dataKey.replace('For a', 'A')}</b> with 1 child, earning 100% FPL, pays
    <b>${toPercent(payload.value)}</b> of their household income for <b>${payload.payload.age_group.toLowerCase()}</b> child care.
  `;
    }
    return 'Insufficient sample size';
  };

  return (
    <>
      {error && <Typography variant="body1" color="error">{error.message}</Typography>}
      <BarChart
        valueFormatter={toPercent}
        formatterFunction={formatterFunction}
        height={height}
        ready={ready}
        data={data}
        keys={keys}
        groupKey={groupKey}
        title={title}
        colors={[primaryColor, secondaryColor]}
      />
    </>
  );
}

export default AveragePriceByChildAgePoverty;
